import { render, staticRenderFns } from "./MarketplaceHostingInstitutionsFiltered.vue?vue&type=template&id=68222917"
import script from "./MarketplaceHostingInstitutionsFiltered.vue?vue&type=script&lang=js"
export * from "./MarketplaceHostingInstitutionsFiltered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports